import theme from '../../../styles/theme.mjs';
import { BreakingNewsType } from '../../../types/story.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import TextComponent from '../../Typography/Text/Text.mjs';
import styled from 'styled-components';

const breakingNewsBannerColors = {
    [BreakingNewsType.NEWS]: theme.colors.sirenRedShade,
    [BreakingNewsType.WEATHER]: theme.colors.brightYellow
};
const breakingNewsBannerTitleColors = {
    [BreakingNewsType.NEWS]: theme.colors.white,
    [BreakingNewsType.WEATHER]: theme.colors.slate
};
const BORDER_SIZE = '4px';
const StyledBreakingNewsLink = styled.a `
  display: block;
  text-decoration: none;
  transition-property: max-height, opacity;
  transition-duration: ${props => props.theme.animation.duration.moderate2};
  transition-timing-function: ${({ isVisible }) => isVisible
    ? theme.animation.easing.expressive.entrance
    : theme.animation.easing.expressive.exit};
  max-height: ${({ isVisible }) => (isVisible ? '300px' : '0px')};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  overflow: hidden;
`;
const StyledBreakingBannerFlexContainer = styled(FlexContainer) `
  position: relative;
  border-bottom: ${BORDER_SIZE} solid ${({ type }) => breakingNewsBannerColors[type]};
  box-sizing: border-box;
  background-color: ${props => props.type === BreakingNewsType.NEWS
    ? props.theme.colors.sirenRedShade
    : props.theme.colors.backgroundColor};

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    height: 70px;
  }
`;
const StyledBreakingBannerText = styled(TextComponent) `
  text-wrap: balance;
  max-width: none;
  text-align: center;
  padding: 0.5rem 1.5rem;
  width: 100%;
  font-size: ${props => props.theme.typography.text.tiny.fontSize};
  line-height: ${props => props.theme.typography.text.tiny.lineHeight};
  margin: 0;
  box-sizing: border-box;
  color: ${props => props.type === BreakingNewsType.NEWS ? props.theme.colors.white : props.theme.colors.textColor};

  svg {
    height: 12px;
    margin-left: 0.5rem;
    transform: translateY(1px);
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    font-size: ${props => props.theme.typography.text.small.fontSize};
    line-height: ${props => props.theme.typography.text.small.lineHeight};
    padding: 0 1.5rem;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    max-width: 620px;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    font-size: ${props => props.theme.typography.text.medium.fontSize};
    line-height: ${props => props.theme.typography.text.medium.lineHeight};
    padding: 0 2.5rem;
  }
`;
const StyledBreakingBannerFlexTitle = styled(FlexContainer) `
  width: 100%;
  height: 100%;
  min-height: 32px;
  background-color: ${({ type }) => breakingNewsBannerColors[type]};
  color: ${({ type }) => breakingNewsBannerTitleColors[type]};

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    max-width: 169px;
    padding-top: calc(${BORDER_SIZE} + ${BORDER_SIZE} / 2);
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    max-width: 209px;
  }
`;
const StyledBreakingBannerTitleText = styled(TextComponent) `
  margin: 0;
  line-height: ${props => props.theme.typography.text.small.fontSize};
  font-size: ${props => props.theme.typography.text.small.fontSize};
  text-transform: uppercase;
  text-align: center;
  color: inherit;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    white-space: pre-line;
    word-spacing: 100vw;
    line-height: 1.5rem;
    font-size: 1.5rem;
  }
`;
const StyledBreakingBannerCloseButtonFlexContainer = styled(FlexContainer) `
  position: absolute;
  top: 0.5rem;
  right: 1rem;

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: ${({ type }) => breakingNewsBannerTitleColors[type]};
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    position: static;
    max-width: 169px;
    padding-right: 3.75rem;

    svg {
      path {
        fill: ${props => props.type === BreakingNewsType.NEWS
    ? props.theme.colors.white
    : props.theme.colors.iconColor};
      }
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    max-width: 209px;
    width: 100%;
  }
`;

export { StyledBreakingBannerCloseButtonFlexContainer, StyledBreakingBannerFlexContainer, StyledBreakingBannerFlexTitle, StyledBreakingBannerText, StyledBreakingBannerTitleText, StyledBreakingNewsLink };
//# sourceMappingURL=BreakingNewsBanner.styles.mjs.map
